import { PLATFORMS } from '../constants';

export const sendMessage = (platform, isMovil, message, isJson = true) => {
    const msg = isJson ? JSON.stringify(message) : message;

    if (isMovil) {
        window.ReactNativeWebView?.postMessage(msg);
        return;
    }

    switch (platform) {
        case PLATFORMS.IOS:
            window.webkit?.messageHandlers?.messageHandlersName?.postMessage(msg);
            break;
        case PLATFORMS.ANDROID:
            window.ResponseAdo?.handleEvent(msg);
            break;
        case PLATFORMS.REACT_NATIVE:
            window.ReactNativeWebView?.postMessage(msg);
            break;
        case PLATFORMS.WEB:
        default:
            window.parent.postMessage(msg, '*');
            break;
    }
};

export const sendBackMessage = (platform, isMovil) => {
    const backData = { type: 'success', status: 'back', data: '' };

    if (platform === PLATFORMS.IOS) {
        window.webkit?.messageHandlers?.messageHandlersName?.postMessage(JSON.stringify(backData));
        return;
    }

    if (platform === PLATFORMS.ANDROID) {
        window.FinishClose?.goBack();
        return;
    }

    if (platform === PLATFORMS.REACT_NATIVE || isMovil) {
        window.ReactNativeWebView?.postMessage(JSON.stringify(backData));
        return;
    }

    window.parent.postMessage(JSON.stringify({ origin: 'liveness', step: 'back', ...backData }), '*');
};
